import { useLocation, useParams } from "react-router-dom";
import { HOME_ROUTE, STAFF_HISTORY_ROUTE, STAFF_IDM_ROUTE, STAFF_PAYMENT_DETAILS_ROUTE } from "../../app/router/routes";
import { useAppSelector } from "../../app/store/store";
import { LayoutPages } from "../layoutPages";
import { FEATURES, FEATURE_SECTIONS, hasFeature, hasFeatureGrant } from "../../entities/my";
import { StaffCardWidget, StaffHistoryWidget, StaffIdm, StaffPaymentDetailsWidget, StaffWidget } from "../../widgets/staff";
import { AccessDeniedRedirect } from "../../shared/ui/accessDeniedRedirect";
import { StaffProfileSections } from "./StaffProfileSections";
import { WorkTgFilter } from "../../widgets/workTgFilter";
import { getStaffDetailPath, getStaffListPath, getStaffReturnPath, getStaffSection } from '../../app/router/staffNavigation';

export default function StaffPage() {
    const {user_id} = useParams<{user_id: string}>()
    const {pathname, search} = useLocation()
    const section = getStaffSection(pathname)
    const archived = pathname === getStaffListPath(section, true)
    const backPath = getStaffReturnPath(search, section)

    const {my} = useAppSelector(s => s.myReducer)
    const canOpenStaffSection = hasFeature(my, FEATURE_SECTIONS.STAFF)
    const targetUserId = user_id && !Number.isNaN(Number(user_id)) ? Number(user_id) : undefined
    const canListStaff = hasFeatureGrant(my, FEATURES.IDM.STAFF_LIST)
    const canReadIdmStaff = hasFeature(my, FEATURES.IDM.STAFF_READ, targetUserId)
    const canReadScheduleHistory = targetUserId !== undefined && hasFeature(my, FEATURES.AUDIT.SCHEDULE_HISTORY_READ, targetUserId)
    const canReadStaff = canReadIdmStaff
    const isStaffCardRoute = Boolean(user_id)
    const isStaffIdmRoute = Boolean(user_id) && pathname.endsWith('/idm')
    const isStaffHistoryRoute = Boolean(user_id) && pathname.endsWith('/history')
    const isStaffPaymentDetailsRoute = Boolean(user_id) && pathname.endsWith('/payment-details')
    const isAccess = canOpenStaffSection && (canListStaff || (isStaffCardRoute && canReadStaff))

    if(!isAccess){
        return <AccessDeniedRedirect to={HOME_ROUTE.path} />
    }

    if(isStaffCardRoute && !canReadStaff){
        return <AccessDeniedRedirect to={HOME_ROUTE.path} />
    }

    if(isStaffIdmRoute && !canReadIdmStaff){
        return <AccessDeniedRedirect to={HOME_ROUTE.path} />
    }

    if(isStaffHistoryRoute && !canReadScheduleHistory){
        return <AccessDeniedRedirect to={getStaffDetailPath(String(targetUserId), section, search)} />
    }

    return (
        <LayoutPages
            title={
                isStaffIdmRoute
                    ? STAFF_IDM_ROUTE.name
                    : isStaffPaymentDetailsRoute
                        ? STAFF_PAYMENT_DETAILS_ROUTE.name
                        : isStaffHistoryRoute
                            ? STAFF_HISTORY_ROUTE.name
                            : isStaffCardRoute
                                ? (section === 'performers' ? 'Профиль исполнителя' : 'Профиль работника')
                                : `${archived ? 'Архив ' : ''}${section === 'performers' ? (archived ? 'исполнителей' : 'Исполнители') : (archived ? 'работников' : 'Работники')}`
            }
            titleLink={isStaffCardRoute ? backPath : undefined}
        >
            {
                isStaffIdmRoute
                    ? <StaffIdm key={`staff-idm-${pathname}`} />
                    : isStaffPaymentDetailsRoute
                        ? <StaffPaymentDetailsWidget key={`staff-payment-details-${pathname}`} />
                    : isStaffHistoryRoute
                        ? <StaffHistoryWidget key={`staff-history-${pathname}`} />
                    : isStaffCardRoute
                        ? <StaffCardWidget
                            key={`staff-card-${pathname}`}
                            renderProfileSections={context => <StaffProfileSections {...context} />}
                        />
                        : <StaffWidget
                            key={`staff-list-${pathname}`}
                            section={section}
                            archived={archived}
                            renderWorkTgFilter={({selectedIds, onChange, hideLabel}) => (
                                <WorkTgFilter
                                    label={hideLabel ? "" : undefined}
                                    initWorkTgIds={selectedIds}
                                    setWorkTgIds={onChange}
                                />
                            )}
                        />
            }
        </LayoutPages>
    )
}
